import { createChildFormViewContainer } from 'factories/ChildFormView'
import actions from 'actions/assets/assetWarranties'
import Component from 'components/Assets/Warranties/FormView'

export default createChildFormViewContainer({ actions })(Component)
